// 'participants' 영역 문구. 키는 ko / en 에 똑같이 둔다.
const participants = {
  ko: {
    eyebrow: 'Participant List',
    title: '참가 목록',
    desc: '대회를 선택하면 해당 대회에 등록된 참가자 목록을 확인할 수 있습니다.',
    selectTournament: '대회 선택',
    listTitle: '참가자 목록',
    addParticipant: '참가자 추가',
    downloadExcel: '엑셀 다운로드',
    selectTournamentPrompt: '위에서 대회를 선택해 주세요.',
    noTournaments: '등록된 대회가 없습니다.',
    loadTournamentsError: '대회 목록을 불러오지 못했습니다.',
    noParticipants: '등록된 참가자가 없습니다.',
    loadParticipantsError: '참가자 목록을 불러오지 못했습니다.',
    cancelConfirm: '{name} 님의 참가 신청을 취소하시겠습니까?\n취소 후에는 복구할 수 없습니다.',
    cancelError: '참가 취소에 실패했습니다. 잠시 후 다시 시도해 주세요.',
    processing: '처리 중...',
    cancelApplication: '참가 취소',
    columns: {
      name: '이름',
      association: '소속 협회',
      gym: '도장명',
      coach: '지도자명',
      grade: '학년',
      birth: '생년월일',
      gender: '성별',
      height: '신장',
      phone: '연락처',
      parentPhone: '보호자 연락처',
      status: '상태',
      payment: '결제',
      amount: '참가비',
      appliedAt: '신청일',
      actions: '관리',
    },
    status: {
      APPLY: '신청',
    },
    paymentStatus: {
      READY: '결제대기',
      PAID: '결제완료',
      CANCELLED: '취소',
    },
    excel: {
      sheetName: '참가자목록',
      fileLabel: '참가자목록',
      defaultFileName: '대회',
      columns: {
        id: '번호',
        competitionCode: '대회코드',
        competitionName: '대회명',
        name: '이름',
        association: '소속 협회',
        gym: '도장명',
        coach: '지도자명',
        grade: '학년',
        birth: '생년월일',
        gender: '성별',
        height: '신장(cm)',
        participantPhone: '참가자 연락처',
        parentPhone: '보호자 연락처',
        status: '상태',
        orderId: '주문번호',
        paymentMethod: '결제수단',
        paymentStatus: '결제상태',
        amount: '참가비(원)',
        appliedAt: '신청일시',
      },
    },
  },
  en: {
    eyebrow: 'Participant List',
    title: 'Participants',
    desc: 'Select a tournament to see its registered participants.',
    selectTournament: 'Select tournament',
    listTitle: 'Participant list',
    addParticipant: 'Add participant',
    downloadExcel: 'Download Excel',
    selectTournamentPrompt: 'Please select a tournament.',
    noTournaments: 'No tournaments yet.',
    loadTournamentsError: 'Could not load tournaments.',
    noParticipants: 'No participants registered yet.',
    loadParticipantsError: 'Could not load participants.',
    cancelConfirm: "Cancel {name}'s registration?\nThis cannot be undone.",
    cancelError: 'Could not cancel the registration. Please try again later.',
    processing: 'Processing...',
    cancelApplication: 'Cancel registration',
    columns: {
      name: 'Name',
      association: 'Association',
      gym: 'Gym',
      coach: 'Coach',
      grade: 'Grade',
      birth: 'Date of birth',
      gender: 'Gender',
      height: 'Height',
      phone: 'Phone',
      parentPhone: 'Parent/guardian phone',
      status: 'Status',
      payment: 'Payment',
      amount: 'Amount',
      appliedAt: 'Applied at',
      actions: 'Actions',
    },
    status: {
      APPLY: 'Applied',
    },
    paymentStatus: {
      READY: 'Pending',
      PAID: 'Paid',
      CANCELLED: 'Cancelled',
    },
    excel: {
      sheetName: 'Participants',
      fileLabel: 'participants',
      defaultFileName: 'tournament',
      columns: {
        id: 'No.',
        competitionCode: 'Tournament code',
        competitionName: 'Tournament',
        name: 'Name',
        association: 'Association',
        gym: 'Gym',
        coach: 'Coach',
        grade: 'Grade',
        birth: 'Date of birth',
        gender: 'Gender',
        height: 'Height (cm)',
        participantPhone: 'Participant phone',
        parentPhone: 'Parent/guardian phone',
        status: 'Status',
        orderId: 'Order ID',
        paymentMethod: 'Payment method',
        paymentStatus: 'Payment status',
        amount: 'Amount (KRW)',
        appliedAt: 'Applied at',
      },
    },
  },
};

export default participants;
